<template>
    <card-box class="enterpriseAuthe" title="认证信息">

        <el-form
                class="el_form_1"
                ref="companyAuthInfo"
                :rules="companyAuthInfo_rules"
                :model="companyAuthInfo"
                label-width="auto"
                v-if="authStatus == 0">
            <el-form-item label="真实姓名" prop="userName">
                <el-input v-model="companyAuthInfo.userName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="cardId">
                <el-input v-model="companyAuthInfo.cardId" maxlength="18" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input v-model="companyAuthInfo.userAccount" disabled></el-input>
            </el-form-item>
            <el-form-item label="短信验证码" prop="verifyCode">
                <div class="verifica">
                    <el-input v-model="companyAuthInfo.verifyCode" maxlength="6" placeholder="请输入短信验证码"></el-input>
                    <div
                            @click="sendByPhone('userAccount')"
                            class="butn"
                    >{{verifica_userAccount?"已发送("+verifica_userAccount+"s)":verifica_userAccount===0?"重新发送":"发送验证码"}}</div>
                </div>
            </el-form-item>
            <el-form-item label="上传身份证正反面" prop="resourceEntitys">
                <div class="IDCards">
                    <div>
                        <el-upload
                                action
                                :http-request="img_upload"
                                accept=".jpg, .jpeg, .png"
                                :show-file-list="false"
                                :before-upload="beforeAvatarUpload"
                                :data="{key:0}">
                            <el-image
                                    :src="companyAuthInfo.resourceEntitys[0]?companyAuthInfo.resourceEntitys[0].filePath:''">
                                <div slot="error">
                                    <img src="@/assets/img/user/pic_idface.png" alt />
                                </div>
                            </el-image>
                            <!-- <el-image :src="companyAuthInfo.resourceEntitys[1].filePath">
                              <div slot="error">
                                <img src="@/assets/img/user/pic_idface.png" alt />
                              </div>
                            </el-image>-->
                            <div>上传身份证人像面</div>
                        </el-upload>
                    </div>
                    <div>
                        <el-upload
                                action
                                :http-request="img_upload"
                                accept=".jpg, .jpeg, .png"
                                :show-file-list="false"
                                :before-upload="beforeAvatarUpload"
                                :data="{key:1}">
                            <el-image
                                    :src="companyAuthInfo.resourceEntitys[1]?companyAuthInfo.resourceEntitys[1].filePath:''">
                                <div slot="error">
                                    <img src="@/assets/img/user/pic_idback.png" alt />
                                </div>
                            </el-image>
                            <div>上传身份证国徽面</div>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="上传手持身份证件头像面照片" prop="resourceEntitys">
                <div class="IDCards">
                    <div>
                        <el-upload
                                action
                                :http-request="img_upload"
                                accept=".jpg, .jpeg, .png"
                                :show-file-list="false"
                                :before-upload="beforeAvatarUpload"
                                :data="{key:2}">
                            <el-image
                                    :src="companyAuthInfo.resourceEntitys[2]?companyAuthInfo.resourceEntitys[2].filePath:''">
                                <div slot="error">
                                    <img src="@/assets/img/user/shouchishenfenzheng.png" alt />
                                </div>
                            </el-image>
                            <!-- <el-image :src="companyAuthInfo.resourceEntitys[1].filePath">
                              <div slot="error">
                                <img src="@/assets/img/user/pic_idface.png" alt />
                              </div>
                            </el-image>-->
                            <div>上传身份证人像面</div>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button :loading="loding_s"  class="submit_butn" type="primary" @click="onSubmit('companyAuthInfo')">提交认证</el-button>
            </el-form-item>
        </el-form>
        <div class="authStatus">
            <div  v-if="authStatus==3" class="submit_succeed">
                <img src="@/assets/img/user/shenhezhong.png" alt />
                <div>提交成功！我们将在1个工作日完成资料审核</div>
            </div>
            <div v-if="authStatus==1" class="succeed">
                <img src="@/assets/img/user/pic_finished.png" alt />
                <div>完成认证</div>
            </div>
            <div v-if="authStatus==2" class="failure">
                <img src="@/assets/img/user/pic_filed.png" alt />
                <div class="tx">认证未通过</div>
                <div class="hite">{{companyAuthInfo.remark}}</div>
                <div class="hite">您上传的证件有误请重新进行认证</div>
                <div class="butn" @click="get_authStatus()">重新认证</div>
            </div>
        </div>

    </card-box>
</template>

<script>
    export default {
        name: "personalAuthentication",
        data() {
            return {
                companyAuthInfo: {
                    cardId: "",
                    creditCode: "",
                    authenName: "",
                    userName: "",
                    userAccount: '',
                    resourceEntitys: [
                        {
                            attribute: "身份证人像面",
                            fileId: "",
                            filePath: "",
                            type: 1
                        },
                        {
                            attribute: "身份证国徽面",
                            fileId: "",
                            filePath: "",
                            type: 2
                        },
                        {
                            attribute: "手持身份证",
                            fileId: "",
                            filePath: "",
                            type: 3
                        },
                    ]
                },
                companyAuthInfo_rules: {
                    cardId: [
                        {required: true, message: "请输入身份证号", trigger: "blur"}
                    ],
                    userName: [
                        {required: true, message: "请输入真实姓名", trigger: "blur"}
                    ],
                    authenName: [
                        { required: true, message: "请输入法定代表人姓名", trigger: "blur" }
                    ],
                    verifyCode: [
                        { required: true, message: "请输入验证码", trigger: "blur" }
                    ],
                    resourceEntitys: [
                        { required: true, message: "证件不能为空", trigger: "blur" }
                    ],
                },
                verifica_authenPhone: false,
                verifica_userAccount: false,
                loding_s: false,
                userInfo:{},
                authStatus:'',
                id:'',
                userAccount:'',
                loginAccount:'',
            };
        },
        components: {
        },
        created() {
            var pagename = window.top.document.URL
            var temp2 = pagename.split('?')[1];
            var pram2 = new URLSearchParams('?'+temp2);
            var token =pram2.get('token')
            this.userAccount =pram2.get('userAccount')
            this.companyAuthInfo.userAccount = this.userAccount
            localStorage.setItem("SET_TOKEN", token);
            this.get_query()
        },
        methods:{
            // 限制图片格式
            beforeAvatarUpload(file) {
                const testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type)
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!testmsg) {
                    this.$message({
                        message: "上传图片只能是 .jpg, .jpeg, .png 格式!",
                        type: "error"
                    });
                    return false;
                }
                if (!isLt2M) {
                    this.$message({
                        message: "上传图片大小不能超过 5MB!",
                        type: "error"
                    });
                    return false;
                }
                return testmsg  && isLt2M;
            },

            get_authStatus(){
                this.authStatus = 0
            },
            get_query(){
                var that = this;
                that.$SIF.httpPost({
                    url: that.$SIF._serve.auth + "/auth/Person/query/personinfo",
                    succFun: res => {
                        if(res.data){
                            that.authStatus = res.data.authStatus
                            if(res.data.resourceEntitys.length ==0){
                                that.resourceEntitys = that.companyAuthInfo.resourceEntitys
                                that.companyAuthInfo = res.data
                                that.companyAuthInfo.resourceEntitys = that.resourceEntitys
                                this.companyAuthInfo.userAccount = this.userAccount
                            }else {
                                that.companyAuthInfo = res.data;
                                for (var k = 0; k < res.data.resourceEntitys.length; k++) {
                                    that.get_img(res.data.resourceEntitys[k].fileId,k)
                                }
                            }
                            this.id = res.data.id
                        }else {
                            this.authStatus =0
                        }

                    },failFun:res=>{
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_img(a,k){
                var that = this;
                that.$SIF.downloadFile({
                    params: { id: a },
                    succFun: function(res) {
                        that.$set(that.companyAuthInfo.resourceEntitys[k], "filePath", res.data.url);
                    }
                });
            },
            onSubmit(companyAuthInfo){
                if(!this.companyAuthInfo.resourceEntitys[0].filePath||!this.companyAuthInfo.resourceEntitys[1].filePath||!this.companyAuthInfo.resourceEntitys[2].filePath){
                    this.$message({
                        message: "照片信息不能为空",
                        type: "warning"
                    });
                    return;
                }
                this.$refs[companyAuthInfo].validate((valid) => {
                    if (valid) {
                        this.loding_s = true
                        if(this.id ){
                            this.uir = this.$SIF._serve.auth + "/auth/Person/update/personinfo"
                            // this.companyAuthInfo.id =this.id
                        }else {
                            this.uir = this.$SIF._serve.auth + "/auth/Person/add/personinfo"
                        }
                        this.$SIF.httpPost({
                            url: this.uir,
                            data: {
                                ...this.companyAuthInfo,
                                authType: 0,
                                authWay: 1,
                            },
                            succFun: res => {
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                this.authStatus = 3
                                // this.$SIF.getUserInfo({
                                //     succFun:res=> {
                                //         this.userInfo = res.data;
                                //         // this.$store.commit("SET_USERINFO", res.data);
                                //     }
                                // });
                                // this.$SIF.setLocalStorage('userInfo', this.userInfo)
                                this.loding_s = false
                                // this.$router.go(-1); //返回上一层
                            },failFun:res=>{
                                this.loding_s = false
                                this.$message({
                                    message: res.msg,
                                    type: 'warning'
                                });
                            }
                        });
                    }
                })

            },
            img_upload(dt) {
                dt.data["business"] = "private";
                dt.data["project"] = "web-sign";
                var that = this;
                this.$SIF.uploadFile({
                    params: dt,
                    succFun: function(res) {
                        if (
                            that.companyAuthInfo.resourceEntitys[dt.data.key] &&
                            that.companyAuthInfo.resourceEntitys[dt.data.key].fileId
                        ) {
                            that.$SIF.delFile({
                                params: {
                                    id: that.companyAuthInfo.resourceEntitys[dt.data.key].fileId
                                }
                            });
                        }
                        that.companyAuthInfo.resourceEntitys[dt.data.key]["filePath"] =
                            res.data.downloadUrl;
                        that.companyAuthInfo.resourceEntitys[dt.data.key]["fileId"] =
                            res.data.id;
                    }
                });
            },
            sendByPhone(key) {
                var that = this;
                var myreg = /^[1][0-9][0-9]{9}$/;
                if (myreg.test(this.companyAuthInfo[key])) {
                    if (!this["verifica_" + key]) {
                        this.$SIF.httpPost({
                            url: this.$SIF._serve.usermanage + "/sms/function/sendCodebyContact",
                            data: {
                                appId:'0000000033',
                                useWhere: 101,
                                toPhone: this.companyAuthInfo[key]
                            },
                            succFun: res => {
                                this.$message({
                                    message: res.msg,
                                    type: 'success'
                                });
                                that.verify_num("verifica_" + key);
                            },failFun:res=>{
                                this.loding_s = false
                                this.$message({
                                    message: res.msg,
                                    type: 'warning'
                                });
                            }
                        });
                    }
                } else {
                    this.$message({
                        message: "手机号格式不正确",
                        type: "warning"
                    });
                }
            },

            verify_num(key) {
                var that = this;
                this[key] = 60;
                var interval = setInterval(() => {
                    if (this[key] < 1) {
                        clearTimeout(interval);
                    } else {
                        this[key] = this[key] - 1;
                    }
                }, 1000);
            },
        }
    }
</script>

<style scoped type="text/css">
    .el_form_1{
        padding-top: 20px;
        width: 700px;
        margin: 0 auto;
    }
    .el_form_1 .card-box-box{
        overflow: hidden;
        width: 700px;
        margin: 0 auto;
    }
    .enterpriseAuthe {
        height: 100%;
        width: 100%;
    }
    .authStatus {
        text-align: center;
        margin-top: 80px;
    }
    .authStatus > div {
        font-size: 20px;
        color: #1d9b62;
        line-height: 20px;
    }
    .authStatus img {
        margin-bottom: 10px;
        display: inline-block;
    }
    .authStatus .failure .tx {
        color: #ff7904;
    }
    .authStatus .failure .hite {
        font-size: 12px;
        color: #717171;
        width: 100%;
        margin: 10px auto;
        text-align: center;
        line-height: 18px;
    }
    .authStatus .failure .butn {
        width: 128px;
        height: 33px;
        border-radius: 8px;
        border: 1px solid rgba(49, 202, 132, 1);
        color: #31ca84;
        font-size: 16px;
        line-height: 31px;
        margin: 10px auto;
        cursor: pointer;
    }
    .submit_succeed {
        margin-top: 90px;
        text-align: center;
    }
    .submit_succeed img{
        width: 110px;
        margin-bottom: 20px;
    }
    .submit_succeed {
        color: #1CA868;
        font-size: 18px;
    }
</style>
<style>
    .enterpriseAuthe .el-steps {
        margin-top: 28px;
        width: 700px;
        margin: 28px auto;
    }
    .enterpriseAuthe .el-step__head.is-process {
        color: #31ca84;
        border-color: #31ca84;
    }
    .enterpriseAuthe .el-step__title.is-process {
        color: #31ca84;
        border-color: #31ca84;
    }
    .enterpriseAuthe .error .el-step__head.is-process {
        color: #FF4A4A;
        border-color: #FF4A4A;
    }
    .enterpriseAuthe .error .el-step__title.is-process{
        color: #FF4A4A;
        border-color: #FF4A4A;
    }
    .enterpriseAuthe .el-form-item__label {
        line-height: 30px;
    }
    .enterpriseAuthe .el-form-item__content {
        line-height: 30px;
    }
    .enterpriseAuthe .el-upload__tip {
        line-height: 20px;
    }
    .enterpriseAuthe .el-step.is-center .el-step__line {
        left: 80%;
        right: -20%;
        background-color: #31ca84;
        height: 1px;
    }

    /*.enterpriseAuthe .el-form {*/
    /*    margin-left: 200px;*/
    /*}*/
    .enterpriseAuthe .el-input {
        width: 294px;
    }
    .enterpriseAuthe .el-form-item__content {
        padding-left: 15px;
    }
    .enterpriseAuthe .el-input__inner {
        height: 30px;
        line-height: 30px;
    }
    .enterpriseAuthe .el-step__title {
        font-size: 14px;
    }
    .enterpriseAuthe .license_example {
        display: flex;
    }
    .enterpriseAuthe .license_example .el-image {
        margin-right: 55px;
        width: 62px;
        border-radius: 2px;
        border: 1px solid rgba(49, 202, 132, 1);
    }
    .enterpriseAuthe .image-slot img {
        display: block;
        width: 56px;
        margin: 1px;
    }
    .enterpriseAuthe .image-slot {
        position: relative;
    }
    .enterpriseAuthe .image-slot > div {
        position: absolute;
        width: 46px;
        height: 22px;
        background: rgba(49, 202, 132, 87);
        border-radius: 3px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        color: #fff;
        right: 0;
        bottom: 0;
    }
    .enterpriseAuthe .IDCards {
        display: flex;
    }
    .enterpriseAuthe .IDCards > div {
        background-color: #f6f6f6;
        width: 132px;
        margin-right: 46px;
        text-align: center;
        padding-top: 15px;
        color: #999999;
        font-size: 12px;
    }
    .enterpriseAuthe .IDCards .el-image img {
        display: block;
    }
    .enterpriseAuthe .IDCards .el-image {
        width: 77px;
        height: 44px;
    }
    .enterpriseAuthe .el-upload > div {
        display: block;
        margin: 0 auto;
    }
    .enterpriseAuthe .el-input__icon {
        line-height: 30px;
    }
    .enterpriseAuthe .submit_butn {
        width: 124px;
        height: 33px;
        background: rgba(49, 202, 132, 1);
        border-radius: 8px;
        margin-left: 69px;
        line-height: 33px;
        padding: 0;
    }
    .enterpriseAuthe .verifica {
        display: flex;
        width: 294px;
        justify-content: space-between;
        align-items: center;
    }
    .enterpriseAuthe .verifica .el-input {
        width: 165px;
    }
    .enterpriseAuthe .verifica .butn {
        width: 90px;
        height: 30px;
        background: rgba(227, 255, 242, 1);
        border-radius: 3px;
        border: 1px solid rgba(49, 202, 132, 1);
        font-size: 14px;
        color: #04c86e;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
    }
    .enterpriseAuthe .verifica .butn.on {
        background: none;
    }
    .card-box-box{
        height: 100%;
        overflow: auto;
        overflow-y: scroll;
        scrollbar-color: transparent transparent;
        scrollbar-track-color: transparent;
        -ms-scrollbar-track-color: transparent;
    }
    .card-box-box::-webkit-scrollbar {
        width: 4px;
        /*height: 4px;*/
    }

    .card-box-box::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }

    .card-box-box::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }
    .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
        font-size: 40px;
    }
    .submit_succeed {
        margin-top: 90px;
        text-align: center;
    }
    .submit_succeed img{
        width: 110px;
        margin-bottom: 20px;
    }
    .submit_succeed {
        color: #1CA868;
        font-size: 18px;
    }
</style>
